import useStyles from './styles';
import useHeaderState from '@/hooks/useHeaderState';
import HeaderLeft from '@/components/HeaderLeft';
import HeaderRight from '@/components/HeaderRight';
import type { HeaderProps } from './types';

const Header = ({ onSettingsClick, hideBack }: HeaderProps) => {
  const classes = useStyles();
  const {
    screen,
    isSeeAllOpen,
    showBackButton,
    showGenerationsButton,
    handleBack,
    handleGenerationsClick,
    handleCloseApp,
    getMobileTitle,
  } = useHeaderState();

  return (
    <header className={classes.header}>
      <HeaderLeft
        screen={screen}
        isSeeAllOpen={isSeeAllOpen}
        showBackButton={hideBack ? false : showBackButton}
        mobileTitle={getMobileTitle()}
        onBack={handleBack}
      />
      <HeaderRight
        showGenerationsButton={showGenerationsButton}
        onGenerationsClick={handleGenerationsClick}
        onCloseApp={handleCloseApp}
        onSettingsClick={onSettingsClick}
      />
    </header>
  );
};

export default Header;
